import React from 'react';
import moment from 'moment';
import {getObjectValue} from '../../../helper/custom-function';
import { calculateLeftDays } from "../../../components/form/date";
import { ExpiryDays } from "../../../components/ui/date";

const TableCheckboxUi = React.forwardRef((props, ref) => {
    const {
        id,
        name,
        checked,
        title,
        onChange,        // optional custom handler
        updateColumn     // standard handler
    } = props;

    const handleChange = (e) => {
        if (onChange) {
            onChange(e); // full control
        } else if (updateColumn) {
            updateColumn(name, e.target.checked); // default behavior
        }
    };

    return (
        <label htmlFor={id}>
            <input
                id={id?.toString()}
                ref={ref}
                type="checkbox"
                name={name}
                checked={checked}
                onChange={handleChange}
            />
            {title && <> {title}</>}
        </label>
    );
});


const SettingDropdownUi = (props) => {
    return (
        <div className="text-end p-3">
            <div className="btn-group">
                <button
                    className="btn btn-outline-info dropdown-toggle p-1"
                    type="button"
                    data-bs-toggle="dropdown"
                >
                    <i className="mdi mdi-18px mdi-settings"></i>
                </button>
                <ul className="dropdown-menu ps-2 pe-2">
                    <li>
                        <TableCheckboxUi
                            id="all"
                            name="all"
                            checked={props.checkedData.all}
                            // updateColumn={(name, checked) => props.updateColumn(name, checked)}
                            updateColumn={props.updateColumn}
                            title="Select All"
                        />
                    </li>
                    {props.fields.map((sett, i) => (
                        <li key={i}>
                            <TableCheckboxUi
                                id={sett?.field?.name ?? sett?.fetch_key}
                                name={sett?.field?.name ?? sett?.fetch_key}
                                checked={props.checkedData[sett?.field?.name ?? sett?.fetch_key]}
                                updateColumn={props.updateColumn}
                                title={sett.title}
                            />
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

const RowDataUi = (props) => {
    return (
        <span>
            {props.fetch_key.includes(".")
            ?
                getObjectValue(props.data, props.fetch_key) || ""
            :
                (
                    props.data_type?.type === 'expiry_at'
                    ?
                        props?.data[props.fetch_key] && (
                        <>
                            {moment(props?.data[props.fetch_key]).format("Do MMM YYYY")}
                            {/* DD/MM/yyyy */}
                            <br/>(<ExpiryDays days={calculateLeftDays(props?.data[props.fetch_key])} />)
                        </>)
                    :
                        props.fetch_key === 'active_status_id'
                        ?
                            <label className={`badge ${props?.data?.active_status_id === 1 ? 'badge-success' : 'badge-danger'}`}>{props?.data?.active_status_id === 1 ? "Active" : "Inactive"}</label>
                        :
                            props.fetch_key === 'created_at'
                            ?
                                <span>{moment(props?.data?.created_at).format("Do MMM YYYY")}</span>
                            :
                                props.data_type?.type === 'array'
                                ?
                                    props?.data[props.fetch_key].map((d, i) => (
                                        <span key={i}>{d?.[props.data_type?.key]}<br/></span>
                                    ))
                                :
                                    props?.data[props.fetch_key]
                )
            }

            {/* field.type === "date"
            ?
                props.data[field.value_key] && (
                    moment(props.data[field.value_key]).format(field.date_type)
                )
            : */}
        </span>
    );
}

export {
    SettingDropdownUi,
    TableCheckboxUi,
    RowDataUi
};